(function() {
    const urlParams = new URLSearchParams(window.location.search);
    const redirectCountry = urlParams.get('__re') ? urlParams.get('__re').toLowerCase() : null;
    const currentPath = window.location.pathname;

    const performRedirect = (newUrl) => {
      window.location.href = newUrl;
    }
  
    if (redirectCountry !== null && window.redirectData) { // If a country is specified, check for that country
      window.redirectData.forEach((data) => {
        const { pagePath, redirectTo, country } = data;
        if (pagePath === currentPath && country === redirectCountry) {
          // Remove the __re parameter from the query string
          urlParams.delete('__re');

          // Log and redirect
          const newUrl = `${redirectTo}?${urlParams.toString()}`;
          performRedirect(newUrl);
        }
      });
  
    } else if (redirectCountry === null && window.redirectData) { // If no country is specified & there are redirects, check for all users flag
      window.redirectData.forEach((data) => {
        const { pagePath, redirectTo, forAllUsers } = data;
        const currentPathQuerystring = `${currentPath}?${urlParams.toString()}`;
        if (pagePath === currentPathQuerystring && forAllUsers === 'true') { // Check if the page path matches and the redirect is for all users

          // Log and redirect
          performRedirect(redirectTo);
        }
      })
    }
  })();
  